"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdPlatformDocumentApi = void 0;
const SdPlatformRequestId_1 = require("../api/SdPlatformRequestId");
const ResourcesApi_1 = require("./commons/ResourcesApi");
/**
 * Actions related to Documents.
 */
class SdPlatformDocumentApi extends ResourcesApi_1.ResourcesApi {
    get __resourcePath() {
        return "documents";
    }
    /**
     * Create a document.
     * @param body - {@link SdPlatformRequestDocumentCreate } body
     * @returns - {@link SdPlatformPostResponse} with {@link SdPlatformResponseDomainAdmin} data
     */
    create(body) {
        return super.__post(SdPlatformRequestId_1.RequestId.DocumentCreate, body);
    }
    /**
     * Query documents.
     * @param query - {@link SdPlatformDocumentQueryParameters} query parameters.
     * @returns - the {@link SdPlatformQueryResponse} query response with array of {@link SdPlatformResponseDocument} as data.
     */
    query(query = {}) {
        return super.__query(SdPlatformRequestId_1.RequestId.DocumentQuery, query);
    }
    /**
     * Delete a document.
     * @param { string } id - the id of a document.
     */
    delete(id) {
        return super.__delete(SdPlatformRequestId_1.RequestId.DocumentDelete, id);
    }
    /**
    * Get a list of documents which are relevant to the requesting user.
    * @param query_parameters - optional, {@link SdPlatformDocumentGetQueryParameters}
    * @returns { Promise<SdPlatformGetResponse<Array<SdPlatformResponseDocumentUser>>> }
    */
    list(query_parameters) {
        return super.__action(SdPlatformRequestId_1.RequestId.DocumentList, ResourcesApi_1.Action.Get, "", query_parameters !== null && query_parameters !== void 0 ? query_parameters : {});
    }
    /**
     * Download a document.
     * @param { string } document_id_or_type
     * @returns : Promise<SdPlatformGetResponse<void>>
     */
    download(document_id_or_type) {
        return super.__action(SdPlatformRequestId_1.RequestId.DocumentDownload, ResourcesApi_1.Action.Get, `${document_id_or_type}/download`, {});
    }
    /**
     * View a document.
     * @param { string } document_id_or_type
     * @returns : Promise<SdPlatformGetResponse<void>>
     */
    view(document_id_or_type) {
        return super.__action(SdPlatformRequestId_1.RequestId.DocumentView, ResourcesApi_1.Action.Get, `${document_id_or_type}/view`, {});
    }
    /**
    * Get a download document url.
    * @param { string } document_id_or_type
    * @returns { string }
    */
    getDownloadUrl(document_id_or_type) {
        return `/browser/v1/documents/${document_id_or_type}/download`;
    }
    /**
     * Get a view document url.
     * @param { string } document_id_or_type
     * @returns { string }
     */
    getViewUrl(document_id_or_type) {
        return `/browser/v1/documents/${document_id_or_type}/view`;
    }
    /**
     * Accept a document
     * @param { string } document_id
     * @param { SdPlatformRequestDocumentAccept } body
     */
    accept(document_id, body) {
        return super.__action(SdPlatformRequestId_1.RequestId.DocumentAccept, ResourcesApi_1.Action.Post, `${document_id}/accept`, body);
    }
}
exports.SdPlatformDocumentApi = SdPlatformDocumentApi;
//# sourceMappingURL=SdPlatformDocumentApi.js.map